import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import * as Types from './types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);

const persistsOn = [
    Types.REQUEST_LOGOUT,
    Types.SET_COMPANY_SELECTED,
    Types.SUCCESS_LOGIN
];

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    filter: mutation => persistsOn.includes(mutation.type)
});

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    plugins: [vuexLocal.plugin]
});
